import DynamicPopups from './DynamicPopups';
export default DynamicPopups;

